import { render } from "./quiz1_1.vue?vue&type=template&id=cd48deae"
import script from "./quiz1_1.vue?vue&type=script&lang=js"
export * from "./quiz1_1.vue?vue&type=script&lang=js"

import "./quiz1_1.vue?vue&type=style&index=0&id=cd48deae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__